/* eslint-ignore */
// @ts-nocheck
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Form } from 'react-bootstrap';
import * as Yup from 'yup';
import { connect } from 'react-redux';

import { toast } from 'react-toastify';
import Button from '../../../../layout/button';

import {
  Container,
  Header,
  Left,
  BackButton,
  Title,
  CloseIcon,
  Question,
  Input,
  FieldName,
  Select,
  Option,
} from '../../styles';
import theme from '~/styles/theme';

class Document extends Component {
  constructor(props) {
    super(props);
    this.state = {
      equipment: '',
      selection: '',
    };
  }

  EquipmentSchema = Yup.object().shape({
    equipment: Yup.string().required('Preencha este campo'),
  });

  handleResponse = (response) => {
    if (response === 'voltar') {
      return this.props.handleClick('01010202');
    }
  };

  getSelectValue = () => {
    const { value } = ReactDOM.findDOMNode(this.select);
    if (value != 'vazio') {
      this.props.handleEquipment(value);
    } else {
      toast.error('Selecione um equipamento');
    }
  };

  render() {
    const { close } = this.props;
    return (
      <Container>
        <Header className="mb-3">
          <Left>
            <BackButton
              onClick={() => this.handleResponse('voltar')}
              title="Voltar"
              className="mdi mdi-arrow-left"
            />
            <Title>Gostaríamos de entender melhor o problema:</Title>
          </Left>
          <CloseIcon title="Fechar" className="mdi mdi-close" onClick={close} />
        </Header>

        <Input>
          <FieldName>Selecione o equipamento *</FieldName>
          <Select
            ref={(select) => {
              this.select = select;
            }}
            as="select"
          >
            <Option disabled selected value="vazio">
              Selecione um equipamento...
            </Option>
            <Option>Compressor de GLP</Option>
            <Option>Módulo de regulagem de pressão</Option>
            <Option>Tanque estacionário</Option>
            <Option>Vasilhame</Option>
            <Option>Bomba</Option>
            <Option>Vaporizador</Option>
            <Option>Aquecedor</Option>
            <Option>Cavalete P.A.R</Option>
            <Option>Gerador de água quente</Option>
            <Option>Não especificado</Option>
          </Select>
        </Input>
        <div
          style={{
            width: '100%',
            display: 'flex',
            marginTop: 40,
            marginBottom: 20,
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Button
            style={{ marginTop: 20 }}
            type="submit"
            text="Confirmar"
            color={theme.colors.purple}
            onClick={() => this.getSelectValue()}
          />
        </div>
      </Container>
    );
  }
}

export default connect()(Document);
